import config from "../../config/config";
import coatiLogo from "../../images/coati_logo.png";
import bnaLogo from "../../images/store-header-logo.svg";
import macroLogo from "../../images/macro_logo.svg";

const { REACT_APP_CLIENT_NAME: clientEnv } = config;

const logoByClient = {
  bna: bnaLogo,
  coati: coatiLogo,
  macro: macroLogo,
};

export const Logo = () => {
  const logo = clientEnv ? logoByClient[clientEnv] : coatiLogo;

  return <img src={logo} className="w-logo" alt="client-logo" />;
};
